import React from 'react';
import { AnalyticsPageView } from 'src/components/Analytics';
import { Medium, LessThanMedium } from '@jg/responsive';
import DesktopEncourageShareAndDonate from './DesktopEncourageShareAndDonate';
import MobileEncourageShareAndDonate from './MobileEncourageShareAndDonate';
import { AnalyticsClick } from 'src/redux/modules/analytics';

interface Props {
  ownerName: string;
  pageName: string;
  analyticsClick: AnalyticsClick;
  ownerProfileImage?: string;
}

const EncourageShareAndDonate: React.StatelessComponent<Props> = ({
  ownerName,
  pageName,
  analyticsClick,
  ownerProfileImage,
}) => {
  return (
    <AnalyticsPageView
      eventValue="donate prompt"
      pageSection="page > donate prompt"
      subtype="donate prompt"
    >
      <LessThanMedium>
        <MobileEncourageShareAndDonate
          ownerName={ownerName}
          pageName={pageName}
          analitycsClick={analyticsClick}
          ownerProfileImage={ownerProfileImage}
        />
      </LessThanMedium>
      <Medium>
        <DesktopEncourageShareAndDonate
          ownerName={ownerName}
          pageName={pageName}
          analitycsClick={analyticsClick}
          ownerProfileImage={ownerProfileImage}
        />
      </Medium>
    </AnalyticsPageView>
  );
};

export default EncourageShareAndDonate;



// WEBPACK FOOTER //
// ./src/components/EncourageShareAndDonate/EncourageShareAndDonate.tsx